import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { dashboard_fetch_body } from '@processo/models/entity_dashboard.model';
import { environment } from 'projects/processo/src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntityDashboardServiceService {
  private dashboardWidgetsSubject = new BehaviorSubject<any[]>([]);
  dashboardWidgets$ = this.dashboardWidgetsSubject.asObservable();

  constructor(
    private httpService:HttpClient
  ) { }
  dashboard_fetch(body:dashboard_fetch_body){
    return this.httpService.post(`${environment.base_eru_routes_url}/processo/func/dashboard_fetch`,body)
  }
  fetch_dashboard_data(body:any){
    return this.httpService.post(`${environment.base_eru_routes_url}/processo/func/query_fetch`,body)

  }
  fetchWidgetList(body: {
    "org_id": string,
    "process_id":string
  }) {
    return this.httpService.post(`${environment.base_eru_routes_url}/processo/func/fetch_widget_dtls`, body)
  }

  addWidgetToDashboard(widget: any) {
    const currentWidgets = this.dashboardWidgetsSubject.value;
    const sampleWidget = {
      columns: 1,
      data_template: "",
      label_template: "",
      name: "os_bal_bar",
      parsing: {
        xAxisKey: "fn",
        yAxisKey: "os"
      },
      position: currentWidgets.length + 1,
      query: "prg_os_bal",
      rows: 1,
      styles: {
        borderWidth: 1
      },
      transform: "",
      type: widget.widget_type,
      widget_id: this.generateUUID()
    };
    
    this.dashboardWidgetsSubject.next([...currentWidgets, sampleWidget]);
  }

  private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}
